export default "__VITE_ASSET__c59dc12f__"